export const CONNECT_TO_SOCKET = 'CONNECT_TO_SOCKET';
export const AUTHORIZE_WITH_SOCKET = 'AUTHORIZE_WITH_SOCKET';
export const DISCONNECT_FROM_SOCKET = 'DISCONNECT_FROM_SOCKET';
export const SEND_TO_SOCKET = 'SEND_TO_SOCKET';
export const SOCKET_OPENED = 'SOCKET_OPENED';
export const SOCKET_CLOSED = 'SOCKET_CLOSED';
export const SOCKET_ERROR = 'SOCKET_ERROR';
export const SOCKET_MESSAGE = 'SOCKET_MESSAGE';
//# sourceMappingURL=consts.js.map